import { render, staticRenderFns } from "./PackingAdd.vue?vue&type=template&id=5ff576ce&scoped=true"
import script from "./PackingAdd.vue?vue&type=script&lang=js"
export * from "./PackingAdd.vue?vue&type=script&lang=js"
import style0 from "./PackingAdd.vue?vue&type=style&index=0&id=5ff576ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff576ce",
  null
  
)

export default component.exports